import { render, staticRenderFns } from "./AccountSwitch.vue?vue&type=template&id=3e9ca66f&scoped=true&"
import script from "./AccountSwitch.vue?vue&type=script&lang=js&"
export * from "./AccountSwitch.vue?vue&type=script&lang=js&"
import style0 from "./AccountSwitch.vue?vue&type=style&index=0&id=3e9ca66f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9ca66f",
  null
  
)

export default component.exports